module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/tfl_meeting_invite.c470cbf941039d01a70b78a8ac84072e.svg";